export const iteratorUtil = (start = 0) => {
  let count = start;

  return {
    next: () => {
      return ++count;
    }
  };
};
